import React from 'react';
import { ASSETS_FOLDER } from '../../../../../constants';
import './InfoPhoto.css';

const InfoPhoto = props => (
  <div className="info-photo">
    <img
      src={`${ASSETS_FOLDER}info/img-${props.id}.jpg`}
      alt={`Foto - ${props.name}`}
    />
    <div>{props.name}</div>
  </div>
);

export default InfoPhoto;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/ProjectInfo/InfoPhoto/InfoPhoto.js